import { render, staticRenderFns } from "./ChainList.vue?vue&type=template&id=3d09257a&scoped=true"
import script from "./ChainList.vue?vue&type=script&lang=js"
export * from "./ChainList.vue?vue&type=script&lang=js"
import style0 from "./ChainList.vue?vue&type=style&index=0&id=3d09257a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d09257a",
  null
  
)

export default component.exports